import React from "react";
import { Route } from "react-router"; // react-router v4
import OrderHistoryPage from "src/container/shop/order_history/OrderHistoryPage";
import OrderHistoryDayPage from "src/container/shop/order_history/OrderHistoryDayPage";
import ShopEditPage from "src/container/shop/ShopEditPage";
// import ShopMenuEditPage from 'src/container/shop/menu/ShopMenuEditPage';
// import ShopMenuListPage from 'src/container/shop/menu/ShopMenuListPage';
// import ShopMenuCreatePage from 'src/container/shop/menu/ShopMenuCreatePage';
// import ShopMenuSuccessPage from 'src/container/shop/menu/ShopMenuSuccessPage';
import ShopBagEditPage from "src/container/shop/bags/ShopBagEditPage";
import ShopBagSuccessPage from "src/container/shop/bags/ShopBagSuccessPage";
import ShopEditCompletePage from "src/container/shop/ShopSuccessPage";
import ShopMailSenderCreatePage from "src/container/shop/owners/mail_sender/ShopMailSenderCreatePage";
import ShopMailSenderPage from "src/container/shop/owners/mail_sender/ShopMailSenderPage";
import OrderBreadSearchIndexPage from "src/container/shop/search/order_breads/OrderBreadSearchIndexPage";
import OrderBreadSearchListPage from "src/container/shop/search/order_breads/OrderBreadSearchListPage";
import OrderSearchIndexPage from "src/container/shop/search/orders/OrderSearchIndexPage";
import OrderSearchListPage from "src/container/shop/search/orders/OrderSearchListPage";
import RevenueIndexPage from "src/container/revenues/RevenueIndexPage";

export const ShopRoutes = (props: any) => [
  <Route
    exact
    key={`ShopEditPage`}
    path="/shop/:id/edit"
    render={({ match }) => <ShopEditPage id={match.params.id} {...props} />}
  />,
  <Route
    exact
    key={`ShopEditCompletePage`}
    path="/shop/complete"
    render={() => <ShopEditCompletePage {...props} />}
  />,
  <Route
    exact
    key={`ShopEditCompletePage`}
    path="/shop/:id/edit/complete"
    render={({ match }) => (
      <ShopEditCompletePage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    key={`ShopBagEditPage`}
    path="/shop/:id/bags/edit"
    render={({ match }) => <ShopBagEditPage id={match.params.id} {...props} />}
  />,
  <Route
    exact
    key={`ShopBagSuccessPage`}
    path="/shop/bags/complete"
    render={() => <ShopBagSuccessPage {...props} />}
  />,
  // <Route
  //   exact
  //   key={`ShopMenuListPage`}
  //   path="/shop/:id/menu"
  //   render={({ match }) => <ShopMenuListPage id={match.params.id} {...props} />}
  // />,
  // <Route
  //   exact
  //   key={`ShopMenuCreatePage`}
  //   path="/shop/:id/menu/create"
  //   render={({ match }) => <ShopMenuCreatePage id={match.params.id} {...props} />}
  // />,
  // <Route
  //   exact
  //   key={`ShopMenuEditPage`}
  //   path="/shop/:id/menu/:menu_id/edit"
  //   render={({ match }) => (
  //     <ShopMenuEditPage id={match.params.id} menu_id={match.params.menu_id} {...props} />
  //   )}
  // />,
  // <Route
  //   exact
  //   key={`ShopMenuSuccessPage`}
  //   path="/shop/:id/menu/complete"
  //   render={() => <ShopMenuSuccessPage {...props} />}
  // />,
  <Route
    exact
    key={`OrderHistoryPage`}
    path="/shop/:id/order_history"
    render={({ match }) => <OrderHistoryPage id={match.params.id} {...props} />}
  />,
  <Route
    exact
    key={`OrderHistoryDayPage`}
    path="/shop/:id/order_history/detail/:date"
    render={({ match }) => (
      <OrderHistoryDayPage
        id={match.params.id}
        date={match.params.date}
        {...props}
      />
    )}
  />,
  <Route
    exact
    key={`OrderBreadSearchIndexPage`}
    path="/shop/:id/search/order_breads"
    render={({ match }) => (
      <OrderBreadSearchIndexPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    key={`OrderBreadSearchListPage`}
    path="/shop/:id/search/order_breads/:date"
    render={({ match }) => (
      <OrderBreadSearchListPage
        id={match.params.id}
        date={match.params.date}
        {...props}
      />
    )}
  />,
  <Route
    exact
    key={`OrderSearchIndexPage`}
    path="/shop/:id/search/orders"
    render={({ match }) => (
      <OrderSearchIndexPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    key={`OrderSearchListPage`}
    path="/shop/:id/search/orders/:date"
    render={({ match }) => (
      <OrderSearchListPage
        id={match.params.id}
        date={match.params.date}
        {...props}
      />
    )}
  />,
  <Route
    exact
    key={`ShopMailSenderCreatePage`}
    path="/shop/:id/owners/mail_sender/create"
    render={({ match }) => (
      <ShopMailSenderCreatePage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    key={`ShopMailSenderPage`}
    path="/shop/:id/owners/mail_sender/"
    render={({ match }) => (
      <ShopMailSenderPage id={match.params.id} {...props} />
    )}
  />,
  <Route
    exact
    key={`RevenueIndexPage`}
    path="/revenues"
    render={() => <RevenueIndexPage {...props} />}
  />,
];
